import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Prompt, PromptInput } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<UseMutationOptions<unknown, Error, PromptInput, Prompt>, 'mutationKey' | 'mutationFn'>;
}

export const useEditPromptRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, PromptInput, Prompt>(
    [Entities.Prompts, 'edit', id],
    async (payload: PromptInput) => {
      const { data } = await api.v1AdminPromptsPromptIdPut(id, payload)
      return data
    },
    { ...options }
  )
}
